import { faCartPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
    AddToCart as SourceAddToCart
} from 'SourceComponent/AddToCart/AddToCart.component';

import './AddToCart.override.style';

/** @namespace Elganso/Component/AddToCart/Component */
export class AddToCartComponent extends SourceAddToCart {
    render() {
        const {
            mix,
            addProductToCart,
            layout,
            isDisabled,
            isAdding,
            preorder,
            unselectedOptions,
            sku,
            device: { isMobile },
            isProductCard
        } = this.props;

        let text = '';

        if (preorder && unselectedOptions.length === 0 && mix.block !== 'ProductCard') {
            text = isAdding ? __('Adding...') : __('Preorder');
        } else {
            text = isAdding ? __('Adding...') : __('Añadir');
        }

        return (
            <button
              onClick={ addProductToCart }
              block="Button AddToCart"
              mix={ mix }
              mods={ { layout } }
              disabled={ isDisabled || isAdding }
              data_add_sku={ sku }
            >
                { isProductCard && isMobile
                    ? <FontAwesomeIcon icon={ faCartPlus } />
                    : (
                        <>
                            { this.renderCartIcon() }
                            <span>{ text }</span>
                        </>
                    ) }
            </button>
        );
    }
}

export default AddToCartComponent;
